export enum HubSpotStatusConnectionErrorsEnum {
  INVALID_CREDENTIALS = 'INVALID_CREDENTIALS',
  NO_CRM_ADMIN = 'NO_CRM_ADMIN',
  INVALID_CRM_ADMIN = 'INVALID_CRM_ADMIN',
}
